import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useGraphQLImage } from '@/composables/image-graphql';

import { usePageContent } from '@/modules/cms';

/**
 * Use GraphqlImage image from page content
 */
export const GraphQLImageMixin = (prop = 'image') => {
  return defineComponent({
    setup: () => {
      const { pageContent } = usePageContent();
      const { image } = useGraphQLImage(computed(() => pageContent.value?.[prop]));

      return { image };
    },
  });
};
